import styled, { css } from 'styled-components'

import { PAGE_SHAPE } from '../../types'

const mediaPrintRemoveDecoration = css`
  @media print {
    div {
      background: #fff !important;
      color: #000 !important;
      /* Black prints faster */
      box-shadow: none !important;
      text-shadow: none !important;
    }
    img {
      -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
      filter: grayscale(100%);
    }
  }
`

const mediaPrintRemoveMargPaddBackg = css`
  @media print {
    background-color: #fff !important;
    margin: 0;
    padding: 0;
  }
`

const tableCss = css`
  @media print {
    width: 100%;
  }
  .ant-table-thead > tr > th {
    padding: 8px 2px;
  }
  .ant-table-tbody > tr > td {
    padding: 4px 2px;
    font-size: 10px;
    line-height: 1.2;
  }
`

const WarpCenter = styled.div`
  text-align: center;
  width: 100%;
`

const WarpEmpty = styled.div`
  padding: 20px;
  text-align: center;
`

const WrapPage = styled.div<{ pageShape: PAGE_SHAPE }>`
  display: block;
  background: white;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  margin: 0 auto;
  margin-bottom: 24px;
  padding: 38px;
  height: ${({ pageShape }) => `${pageShape.height}${pageShape.unit}`};
  width: ${({ pageShape }) => `${pageShape.width}${pageShape.unit}`};

  @media print {
    border: none;
    box-shadow: none;
    margin: 0;
    height: ${({ pageShape }) => `${pageShape.height - 1}${pageShape.unit}`};
    @page {
      margin: 0;
    }
  }
`

const WrapPageContent = styled.div`
  height: calc(100% - 21px);
`

const WrapSectionTitle = styled.div`
  #content {
    display: flex;
    text-align: center;
    align-content: space-between;
  }

  #image {
    float: left;
    height: 48px;
    left: -20px;
    position: absolute;
    top: 0;
    width: 110px;
  }

  #title {
    float: right;
    text-align: center;
    width: 100%;
  }
  ${mediaPrintRemoveDecoration}
`
export {
  mediaPrintRemoveDecoration,
  mediaPrintRemoveMargPaddBackg,
  tableCss,
  WarpCenter,
  WarpEmpty,
  WrapPage,
  WrapPageContent,
  WrapSectionTitle
}
